import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#338AF3\" d=\"M10.958 10.957s-7.435 9.53-7.442 9.528A11.96 11.96 0 0 0 12 24c6.627 0 12-5.373 12-12z\"></path><path fill=\"#6DA544\" d=\"M10.958 12S3.523 3.513 3.515 3.514A11.96 11.96 0 0 1 12 0c6.627 0 12 5.372 12 12z\"></path><path fill=\"#D80027\" d=\"M3.515 3.515c-4.687 4.687-4.687 12.285 0 16.971 0 .002 20.485-8.485 20.485-8.485z\"></path><path fill=\"#FFDA44\" d=\"M6.26 7.043a4.18 4.18 0 0 0-4.174 4.174v1.565a4.18 4.18 0 0 0 4.174 4.174 4.18 4.18 0 0 0 4.174-4.174v-1.565A4.18 4.18 0 0 0 6.26 7.043m2.609 5.74a2.61 2.61 0 0 1-1.827 2.488v-1.706l1.108-1.107-1.107-1.107v-.916H5.476V12l-1.106 1.106 1.106 1.107v1.058a2.61 2.61 0 0 1-1.826-2.489v-1.565A2.61 2.61 0 0 1 6.26 8.61a2.61 2.61 0 0 1 2.609 2.608z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }